import { safeJson } from "./safeJson";

/**
 * 🧩 ATOMIC J-02 — SAFE FETCH WRAPPER
 * MISSION: Prevent network failures or bad status codes from crashing the intelligence pipeline.
 */
export const safeFetch = async (url: string, options?: RequestInit) => {
    try {
        const response = await fetch(url, options);

        if (response.status === 429) {
            const data = await safeJson(response);
            if (data && data.error === 'quota_exceeded') {
                console.warn(`[safeFetch] QUOTA EXCEEDED for ${url}`, data);
                if (typeof window !== 'undefined') {
                    window.dispatchEvent(new CustomEvent('WINGMAN_QUOTA_EXCEEDED', { detail: data }));
                }
                return null;
            }
            return null;
        }

        if (!response.ok) {
            console.warn(`[safeFetch] Request failed with status ${response.status}: ${url}`);
            return null;
        }

        const data = await safeJson(response);
        return data;

    } catch (err) {
        console.error(`[safeFetch] Critical network or execution failure for ${url}:`, err);
        return null;
    }
};
